const audio = document.querySelector('.audio');
const progressBar = document.querySelector('.progress-bar');
const playIcon = document.querySelector('.play-icon');
const pauseIcon = document.querySelector('.pause-icon');
const playPauseBtn = document.querySelector('.btn-play-pause');
const langBtns = document.querySelectorAll('.btn-lang');
const audioSelect = document.querySelector('.audio-select');
const selectDropdown = document.querySelector('.selectDropdown');
let isDragging = false;
let currentLang = 'fr';

function changeLanguage(language, button) {
  currentLang = language;
  
  langBtns.forEach(btn => {
    const btnLanguage = btn.getAttribute('data-language');
    const currentSrcImg = btn.querySelector('img').src;
    const langIndexImg = currentSrcImg.lastIndexOf('_') + 1;
    const newSrcImg = `${currentSrcImg.slice(0, langIndexImg)}inactive.svg`;
    btn.querySelector('img').src = newSrcImg
    btn.classList.remove('active');
    btn.classList.add('inactive');
  });

  const currentSrcImgActive = button.querySelector('img').src;
  const langIndexImgActive = currentSrcImgActive.lastIndexOf('_') + 1;
  button.classList.remove('inactive');
  button.classList.add('active');
  button.querySelector('img').src = `${currentSrcImgActive.slice(0, langIndexImgActive)}active.svg`;

  if (selectDropdown) {
    const allTitleAudio = selectDropdown.querySelectorAll('span');
    
    allTitleAudio.forEach((title) => {
      if (title.getAttribute('data-language') != currentLang) {
        title.style.display = 'none';
      } else {
        title.style.display = 'initial';
      }
    });

    const currentAudioType = document.querySelector('.selectBtn').getAttribute('data-number');
    document.querySelector('.selectBtn').innerText = document.querySelector(`.selectDropdown .option[data-number="${currentAudioType}"] span[data-language="${currentLang}"]`).textContent;
  }
  
  const currentSrcAudio = audio.src;
  const langIndexAudio = currentSrcAudio.lastIndexOf('_') + 1;
  const extensionIndexAudio = currentSrcAudio.lastIndexOf('.');
  const newSrcAudio = currentSrcAudio.slice(0, langIndexAudio) + currentLang + currentSrcAudio.slice(extensionIndexAudio);
  audio.src = newSrcAudio;
  audio.load();
  resetAudio();
}

function resetAudio() {
  audio.pause();
  audio.currentTime = 0;
  playIcon.classList.remove('hidden');
  pauseIcon.classList.add('hidden');
  progressBar.querySelector('.progress').style.width = 0;
}

function updateProgressBar(event) {
  const rect = progressBar.getBoundingClientRect();
  const offsetX = event.clientX - rect.left;
  const percent = Math.min(1, Math.max(0, offsetX / rect.width));
  audio.currentTime = percent * audio.duration;
}

langBtns.forEach(button => {
  button.addEventListener('click', () => {
    if (!button.classList.contains('active')) {
      const language = button.getAttribute('data-language');
      changeLanguage(language, button);
    }
  });
});

if (playPauseBtn) {
  playPauseBtn.addEventListener('click', () => {
    if (audio.paused) {
      audio.play();
    } else {
      audio.pause();
    }
  });
}

if (audio) {
  audio.addEventListener('pause', () => {
    playIcon.classList.remove('hidden');
    pauseIcon.classList.add('hidden');
  });
  
  audio.addEventListener('play', () => {
    playIcon.classList.add('hidden');
    pauseIcon.classList.remove('hidden');
  });
  
  audio.addEventListener('ended', () => {
    resetAudio();
  });
  
  audio.addEventListener('timeupdate', () => {
    const progress = (audio.currentTime / audio.duration) * 100;
    progressBar.querySelector('.progress').style.width = `${progress}%`;
  });
}

if (progressBar) {
  progressBar.addEventListener('mousedown', (event) => {
    isDragging = true;
    updateProgressBar(event);
  });
}

document.addEventListener('mousemove', (event) => {
  if (isDragging) {
    updateProgressBar(event);
  }
});

document.addEventListener('mouseup', () => {
  isDragging = false;
});

const on = (listener, query, fn) => {
  document.querySelectorAll(query).forEach(item => {
    item.addEventListener(listener, el => {
      fn(el);
    })
  })
}

on('click', '.selectBtn', item => {
  const next = item.target.nextElementSibling;
  next.classList.toggle('toggle');
  item.target.classList.toggle('rotate');
});

on('click', '.option', item => {
  item.target.parentElement.classList.remove('toggle');

  const parent = item.target.closest('.select').children[0];
  parent.setAttribute('data-number', item.target.getAttribute('data-number'));
  parent.innerText = item.target.innerText;

  document.querySelector('.selectBtn').classList.toggle('rotate');

  const audioSrc = audio.src;
  const selectedAudio = item.target.getAttribute('data-number');
  const numberIndexAudio = audioSrc.lastIndexOf('_') - 1;
  const extensionIndexAudio = audioSrc.lastIndexOf('.');
  audio.src = audioSrc.slice(0, numberIndexAudio) + selectedAudio + '_' + currentLang + audioSrc.slice(extensionIndexAudio);

  resetAudio();
});